import React from 'react';
import Radium from 'radium';

import styles from './ImageJumbotronStyle.js';

import text from '../../text.js';

class ImageJumbotron extends React.Component {
    render() {
        return (
            <div>
                <div style={styles.imageDiv}>
                </div>
                <div style={styles.imageOverlay}>
                    <h1 style={styles.h1Text}>{text.imagePlaceholderMain}</h1>
                    <h2 style={styles.h2Text}>{text.imagePlaceholderSubLine}</h2>
                </div>
            </div>
        );
    }
}

export default Radium(ImageJumbotron);


// WEBPACK FOOTER //
// ./src/components/ImageJumbotron/ImageJumbotron.js